import React from 'react';

const ChartIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <path d="M9.12918 15.1208V10.9597M15.3708 15.1208V12M12.25 14.0805V8.87918M3.60288 15.0496C3.13237 13.0437 3.13237 10.9563 3.60288 8.95043C4.25437 6.17301 6.42301 4.00437 9.20043 3.35288C11.2063 2.88237 13.2937 2.88237 15.2996 3.35288C18.077 4.00437 20.2456 6.17301 20.8971 8.95044C21.3676 10.9563 21.3676 13.0437 20.8971 15.0496C20.2456 17.827 18.077 19.9956 15.2996 20.6471C13.2937 21.1176 11.2063 21.1176 9.20044 20.6471C6.42301 19.9956 4.25437 17.827 3.60288 15.0496Z" stroke="#363853" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
);

export default ChartIcon;